// src/config.js
const config = window.config || {};

export const API_URL = config.REACT_APP_API_URL || "http://localhost:5000";
export const WS_URL = config.REACT_APP_WS_URL || "ws://localhost:5000";
